import './price-spider.less';

const removeWidgetBlock = () => {
    const element = document.querySelector('.ps-widget__block');
    if (element) {
        element.parentNode.removeChild(element);
    }
};

const parseWidget = element => {
    const isError =
        element.classList.contains('ps-no-sku') ||
        document.querySelector('.ps-no-results') !== null;

    if (isError) {
        removeWidgetBlock();
    }
};

const startMutationListening = () => {
    try {
        // Sorry guys, I am not a noob developer
        const timerID = setTimeout(removeWidgetBlock, 10000);
        const observedElement = document.getElementById('ps-show-all-initial');
        const observer = new MutationObserver(() => {
            parseWidget(observedElement);
            observer.disconnect();
        });
        const config = { childList: true };
        observer.observe(observedElement, config);

        const observer1 = new MutationObserver(() => {
            clearTimeout(timerID);
            const partnersWidget = document.querySelector('.ps-widget__partners');

            /*const noResultsElements = partnersWidget.querySelector('.ps-no-results');
            if (noResultsElements) {
                return removeWidgetBlock();
            }*/
            const parnersWidgetContainer = partnersWidget.parentNode;
            parnersWidgetContainer.classList.add('ps_widget__container_visible');
            parnersWidgetContainer.nextElementSibling.classList.add('ps_widget__preloader_hidden');

            document.querySelector('.our_partners__link').addEventListener('click', e => {
                e.preventDefault();
                document.getElementById('ps-show-all-initial').click();
            });
            return observer1.disconnect();
        });
        observer1.observe(document.querySelector('.ps-widget__partners'), config);
        return true;
    } catch (error) {
        return false;
    }
};

export const init = () => {
    /**
     * Live reload server injects its script tag,
     * but its attribute src is undifined instead of an emty string
     */
    if (process.env.NODE_ENV === 'development') {
        Array.from(document.getElementsByTagName('script')).forEach(element => {
            // eslint-disable-next-line
            element.src = element.src || '';
        });
        [['ps-account', '1765'], ['ps-country', 'US'], ['ps-language', 'en']].forEach(
            ([name, content]) => {
                const meta = document.createElement('meta');
                meta.name = name;
                meta.content = content;
                document.head.appendChild(meta);
            }
        );
    }

    const psWidgetBlock = document.querySelector('.ps-widget__block');

    if (psWidgetBlock === null) {
        return;
    }

    const script = document.createElement('script');
    script.src = '//cdn.pricespider.com/1/lib/ps-widget.js';
    script.async = 'async';
    script.onload = startMutationListening;
    script.onerror = removeWidgetBlock;
    document.head.appendChild(script);
};
